import { type GradientVariant } from "./types";

/**
 * Animation timing constants for the score animation sequence
 */
export const ANIMATION_TIMINGS = {
  /** Delay before first animation starts */
  INITIAL_DELAY_MS: 1200,
  /** Duration of score counter tick animation */
  SCORE_ANIMATION_DURATION_MS: 1500,
  /** Delay after score animation before showing line item */
  LINE_ITEM_DELAY_MS: 300,
  /** Delay between multiple score changes */
  BETWEEN_CHANGES_DELAY_MS: 2000,
  /** Duration of line item fade-in transition */
  LINE_ITEM_TRANSITION_MS: 300,
} as const;

/**
 * Layout constants for the score display
 */
export const LAYOUT = {
  /** Maximum width for the score content area */
  CONTENT_MAX_WIDTH: 303,
} as const;

/**
 * Background gradients for different score change scenarios
 */
export const GRADIENTS: Record<GradientVariant, string> = {
  /** Green gradient for positive outcomes (on time, earned points) */
  positive: "linear-gradient(180deg, rgba(218, 241, 232, 1) 0%, rgba(251, 242, 232, 1) 100%)",
  /** Red gradient for negative outcomes (late, lost points) */
  negative: "linear-gradient(180deg, rgba(247, 208, 208, 1) 0%, rgba(251, 242, 232, 1) 100%)",
  /** Orange/warning gradient for borderline scenarios (grace period) */
  warning: "linear-gradient(180deg, rgba(255, 236, 219, 1 ) 0%, rgba(251, 242, 232, 1) 100%)",
} as const;

/**
 * Color for the score number display
 */
export const SCORE_COLOR = "rgba(0, 67, 69, 1)";

/**
 * Color for the score number display when the score is negative.
 * Matches Figma's --negative/text token.
 */
export const NEGATIVE_SCORE_COLOR = "rgba(130, 9, 15, 1)";
